import { render } from "./FooterLinkSection.vue?vue&type=template&id=0f956a82"
import script from "./FooterLinkSection.vue?vue&type=script&lang=js"
export * from "./FooterLinkSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__